import { render } from "./RoomList.vue?vue&type=template&id=50f7c929&scoped=true"
import script from "./RoomList.vue?vue&type=script&lang=js"
export * from "./RoomList.vue?vue&type=script&lang=js"

import "./RoomList.vue?vue&type=style&index=0&id=50f7c929&scoped=true&lang=css"

import exportComponent from "C:\\Source\\vueChatApp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f7c929"]])

export default __exports__